import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import styles from './styles.module.scss'

function DurationDropdown({ selectedDuration, handleDurationChange }) {
  const { t } = useTranslation()
  const [durationOptions, setDurationOptions] = useState([
    { label: t('durationOptions.pastNDays', { n: 30 }), value: '4W' },
    { label: t('durationOptions.pastNmonths', { n: 3 }), value: '88D' },
    { label: t('durationOptions.pastNYear', { n: 1 }), value: '364D' }
  ])
  return (
    <Dropdown1
      className={styles.ddnDuration}
      options={durationOptions}
      value={selectedDuration}
      onChange={(e) => handleDurationChange(e)}
    />
  )
}

export default DurationDropdown
